import {FC} from 'react';
import {Button, Paper, Stack, styled, Typography} from '@mui/material';
import {green} from '@mui/material/colors';
import AddIcon from '@mui/icons-material/Add';
import {useGetContractsCidDocumentsQuery} from '../../../../global/services/contracts';
import {useParams} from 'react-router-dom';
import {get, toNumber} from 'lodash';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import {ContractDocumentsTableRow} from './contract-documents-table-row';
import {DeleteDocumentConfirmModal} from './delete-document-confirm-modal';
import {UpdateDocumentModal} from './update-document-modal';
import {AddDocumentModal} from './add-document-modal';
import {documentAddModalOpen} from '../../stores/contract-document-add-modal.store';
import {ContractsSpinner} from '../contracts-spinner';
import {authState} from '../../../../store/auth/atoms';
import {checkAuthorities} from '../../../../shared/helpers/checkAuthorities';
import {CONTRACT_EDIT_ROLES} from '../../../../shared/constants';
import {useRecoilValue} from 'recoil';
import {useCompanyTariffGuard} from '../../../company-tariff';

export const ContractDocuments: FC = () => {
  const {id} = useParams();
  const {user} = useRecoilValue(authState);
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const canEditContract = checkAuthorities(CONTRACT_EDIT_ROLES, [...(user?.roles || [])]);
  const {data, loading} = useGetContractsCidDocumentsQuery({cid: toNumber(id)});
  const documents = get(data, 'content', []);
  const hasDocuments = !!documents.length;
  const firstLoading = loading && !get(data, 'content.length');

  const handleAddDocument = () => {
    if (!checkTariff(true)) return;

    documentAddModalOpen();
  };

  if (firstLoading) return <ContractsSpinner />;

  return (
    <Stack direction="column" spacing={4} alignItems="center">
      <StyledButton
        startIcon={<AddIcon />}
        variant="contained"
        onClick={handleAddDocument}
        disabled={!canEditContract || tariffLoading}
      >
        Добавить документ
      </StyledButton>
      <StyledPaper>
        <StyledTable size="small">
          <TableBody>
            {documents.map((document) => (
              <ContractDocumentsTableRow key={document.id} document={document} canEdit={canEditContract} />
            ))}
          </TableBody>
        </StyledTable>

        <StyledTypography hidden={hasDocuments}>Нет документов</StyledTypography>
      </StyledPaper>
      <DeleteDocumentConfirmModal />
      <UpdateDocumentModal />
      <AddDocumentModal />
    </Stack>
  );
};

const StyledTable = styled(Table)({
  alignSelf: 'flex-start',
});

const StyledButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: green[500],
  alignSelf: 'end',
  '&:hover': {backgroundColor: green[600]},
});

const StyledPaper = styled(Paper)({
  position: 'relative',
  height: 400,
  width: '80%',
  boxShadow: `inset rgba(0, 0, 0, 0.2) 0px 1px 7px -1px,
   rgba(0, 0, 0, 0.14) 0px 1px 1px 0px,
   rgba(0, 0, 0, 0.12) 0px 1px 3px 0px`,
});

const StyledTypography = styled(Typography)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
